import React from "react";
import Body from "../components/Body";
import Header from "../components/Header";

export default function Index() {
  return (
    <div>
      <Header />
      <Body />
    </div>
  );
}
